/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { GContextTypes } from '../../types';
import { GlobalContext } from '../../contexts';
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import { dublicateAlert, errorAlert, successAlert } from '../common/funcs';
import PopupLayout from '../shared/PopupLayout';
import TextFieldLocal from '../shared/TextFieldLocal';
import AutoFieldLocal from '../shared/AutoFieldLocal';
import { useEmployees, useDepartments } from '../../hooks';

// Priority options
const priorityOptions = [
  { value: 'low', name: 'Low', nameAr: 'منخفض' },
  { value: 'medium', name: 'Medium', nameAr: 'متوسط' },
  { value: 'high', name: 'High', nameAr: 'عالي' },
  { value: 'urgent', name: 'Urgent', nameAr: 'عاجل' },
];

const PopupSuggestion = ({
  open,
  onClose,
  row,
  isNew,
  addAction,
  editAction,
  theme,
  words,
  company,
  categories,
}: any) => {
  const [saving, setSaving] = useState(false);
  const [category, setCategory] = useState('');
  const [priority, setPriority] = useState('medium');
  const [emplvalue, setEmplvalue] = useState<any>(null);
  const [departvalue, setDepartvalue] = useState<any>(null);
  const [alrt, setAlrt] = useState({ show: false, msg: '', type: undefined });

  const { register, handleSubmit, errors, reset, setValue } = useForm();
  const {
    translate: { isRTL },
  }: GContextTypes = useContext(GlobalContext);

  const { employees } = useEmployees();
  const { departments } = useDepartments();

  useEffect(() => {
    if (!isNew && row?._id) {
      setValue('title', row.title);
      setValue('desc', row.desc);
      setCategory(row.category || '');
      setPriority(row.priority || 'medium');

      if (row.employeeId && employees) {
        const empl = employees.find((e: any) => e._id === row.employeeId);
        setEmplvalue(empl);
      }
      if (row.departmentId && departments) {
        const dept = departments.find((d: any) => d._id === row.departmentId);
        setDepartvalue(dept);
      }
    }
  }, [row, employees, departments]);

  const onSubmit = async (data: any) => {
    if (!category) {
      await errorAlert(setAlrt, isRTL);
      return;
    }
    setSaving(true);

    const variables: any = {
      _id: row?._id ? row._id : undefined,
      title: data.title,
      desc: data.desc,
      category,
      priority,
      employeeId: emplvalue?._id,
      employeeName: emplvalue?.name,
      employeeNameAr: emplvalue?.nameAr,
      departmentId: departvalue?._id,
    };

    const mutate = isNew ? addAction : editAction;
    const mutateName = isNew ? 'createSuggestion' : 'updateSuggestion';
    await apply(mutate, mutateName, variables);
  };

  const apply = async (mutate: any, mutateName: string, variables: any) => {
    try {
      const res = await mutate({ variables });
      if (res?.data?.[mutateName]?.ok === false) {
        await errorAlert(setAlrt, isRTL);
        setSaving(false);
        return;
      }
      closeModal();
      await successAlert(setAlrt, isRTL);
    } catch (error) {
      onError(error);
    }
  };

  const onHandleSubmit = () => {
    handleSubmit(onSubmit)();
  };

  const closeModal = () => {
    onClose();
    setSaving(false);
    setCategory('');
    setPriority('medium');
    setEmplvalue(null);
    setDepartvalue(null);
    reset();
  };

  const onError = async (error: any) => {
    if (error.message.includes('duplicate')) {
      await dublicateAlert(setAlrt, isRTL);
    } else {
      await errorAlert(setAlrt, isRTL);
      reset();
      console.log(error);
    }
  };

  const title = isRTL
    ? isNew
      ? 'إضافة اقتراح'
      : 'تعديل اقتراح'
    : isNew
      ? 'New Suggestion'
      : 'Edit Suggestion';

  return (
    <PopupLayout
      isRTL={isRTL}
      open={open}
      onClose={closeModal}
      title={title}
      onSubmit={onHandleSubmit}
      theme={theme}
      alrt={alrt}
      maxWidth={'md'}
      saving={saving}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextFieldLocal
            name="title"
            label={isRTL ? 'عنوان الاقتراح' : 'Suggestion Title'}
            register={register}
            errors={errors}
            row={row}
            fullWidth
            mb={0}
            required
          />
        </Grid>

        <Grid item xs={6}>
          <FormControl fullWidth variant="outlined" margin="dense">
            <InputLabel>{isRTL ? 'التصنيف' : 'Category'}</InputLabel>
            <Select
              value={category}
              onChange={(e: any) => setCategory(e.target.value)}
              label={isRTL ? 'التصنيف' : 'Category'}
            >
              {categories.map((cat: any) => (
                <MenuItem key={cat.value} value={cat.value}>
                  {isRTL ? cat.nameAr : cat.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth variant="outlined" margin="dense">
            <InputLabel>{isRTL ? 'الأولوية' : 'Priority'}</InputLabel>
            <Select
              value={priority}
              onChange={(e: any) => setPriority(e.target.value)}
              label={isRTL ? 'الأولوية' : 'Priority'}
            >
              {priorityOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {isRTL ? opt.nameAr : opt.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={6}>
          <AutoFieldLocal
            name="employee"
            title={isRTL ? 'الموظف' : 'Employee'}
            words={words}
            options={employees}
            value={emplvalue}
            setSelectValue={setEmplvalue}
            isRTL={isRTL}
            fullWidth
          ></AutoFieldLocal>
        </Grid>
        <Grid item xs={6}>
          <AutoFieldLocal
            name="department"
            title={isRTL ? 'القسم' : 'Department'}
            words={words}
            options={departments}
            value={departvalue}
            setSelectValue={setDepartvalue}
            isRTL={isRTL}
            fullWidth
          ></AutoFieldLocal>
        </Grid>

        <Grid item xs={12}>
          <TextFieldLocal
            name="desc"
            label={isRTL ? 'تفاصيل الاقتراح' : 'Suggestion Details'}
            register={register}
            errors={errors}
            row={row}
            fullWidth
            multiline
            rows={4}
            mb={0}
          />
        </Grid>
      </Grid>
    </PopupLayout>
  );
};

export default PopupSuggestion;
